import React, {Component} from "react";
import {cx} from "../lib/ClassSet";
import Loading from "./Loading";
import "./ToggleButton.css";

class ToggleButton extends Component {

  render() {
    let classes = cx({
      "ToggleButton": true,
      "u-active": this.props.active,
      "s-on": this.props.state === "on",
      "s-off": this.props.state === "off",
      "s-undecided": this.props.state === "undecided" || this.props.state === ""
    })

    return (
      <div className={classes} onClick={this.handleClick.bind(this)}>
        {this.renderState(this.props.submitting)}
      </div>
    );
  }

  renderState(submitting) {
    if (submitting) {
      return (
        <div className="loadingBg">
          <Loading />
        </div>
      )
    }

    return (
      <div className="bg">
        <div className="toggle" />
      </div>
    )
  }

  handleClick(e) {
    e.preventDefault();
    if (this.props.state === "on") {
      this.props.onToggle("off")
    } else {
      this.props.onToggle("on")
    }
  }

}


ToggleButton.defaultProps = {
  state: "undecided",
  active: true,
  submitting: false
}

export default ToggleButton;